<div class="flex w-full p-0 code-mirror-container">
  <div class="code-mirror-content" [style.height]="editorHeight">
    <ngx-codemirror
      ngDefaultControl
      #codeEditor
      [options]="options"
      [(ngModel)]="query"
      (ngModelChange)="onQueryChange($event)"
      [autoFocus]="autoFocus"
      [disabled]="disabled"
      (codeMirrorLoaded)="onCodeMirrorComponentLoaded($event)"
    >
    </ngx-codemirror>

    @if (error && showValidationMessage) {
      <div style="font-size: 0.75rem; white-space: pre-wrap; color: red">
        {{ validationMessage }}
      </div>
    }
  </div>
</div>
